//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ediExports', {
//        templateUrl: 'views/components/views/ediExports/ediExports.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['ttGridFactory', function (ttGridFactory) {
//            const vm = this;
            
//            vm.grid = new ttGridFactory({
//                rememberId: 'w_ediimportsComponentGrid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3353,
//                    parameters: {}
//                });
//        }]
//    });
//})();
